import { modalRenderer } from '~/modal/modalRendererRegistry';
import { TeamManagementModalContainer } from './teamManagementModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    TeamManagement: undefined;
  }
}

modalRenderer.register('TeamManagement', TeamManagementModalContainer);
